import classNames from 'classnames';
import { useMemo } from 'react';
import { isEmptyText } from "../../lib/index.mjs";
import { Link } from "../Link.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Details(_ref) {
  var {
    title,
    description,
    href,
    id,
    newTab,
    layout,
    hasThumbnail,
    children
  } = _ref;
  var {
    isDescriptionShort,
    isTitleShort
  } = useMemo(() => {
    var _ref2;
    var titleOneLineLength = 33;
    var descriptionOneLineLength = 45;
    if (layout === 'vertical' || !hasThumbnail) {
      titleOneLineLength = 52;
      descriptionOneLineLength = 75;
    }
    return {
      isTitleShort: (title !== null && title !== void 0 ? title : '').length <= titleOneLineLength,
      isDescriptionShort: ((_ref2 = description !== null && description !== void 0 ? description : '') === null || _ref2 === void 0 ? void 0 : _ref2.length) <= descriptionOneLineLength
    };
  }, [title, description, layout, hasThumbnail]);
  return /*#__PURE__*/_jsxs("div", {
    className: 'prezly-slate-bookmark-card-component__details',
    children: [!isEmptyText(title) && /*#__PURE__*/_jsx(Link, {
      id: id,
      className: classNames('prezly-slate-bookmark-card-component__title', {
        'prezly-slate-bookmark-card-component__title--short-title': isTitleShort,
        'prezly-slate-bookmark-card-component__title--short-description': isDescriptionShort
      }),
      href: href,
      newTab: newTab,
      children: title
    }), !isEmptyText(description) && /*#__PURE__*/_jsx("div", {
      className: classNames('prezly-slate-bookmark-card-component__description', {
        'prezly-slate-bookmark-card-component__description--short-title': isTitleShort,
        'prezly-slate-bookmark-card-component__description--short-description': isDescriptionShort
      }),
      children: description
    }), children]
  });
}